module.exports = __webpack_public_path__ + "img/logo-white.b2c892b5.svg";